(function($) {
    $(window).load(function() {
        window.odometerOptions = {
            auto: false
        };
        /* Sliders management */


        $('[name="numbers"]').waypoint(
            {
                handler: function() {
                    $('[data-odometer]').each(
                        function(i, el) {
                            var od = new Odometer({
                                el: el,
                                duration: 10000,
                                value: 0,
                                theme: 'minimal'
                            });
                            od.update($(el).data('count'));
                        }
                    );
                },
                context: '#content.main .wrapper__numbers',
                // offset: '30%'
            }
        );
        $('[data-tipo]').each(
            function(i, el) {
                var tipo = $(el).data('tipo');
                $(el).click(
                    function(e) {
                        e.preventDefault();
                        $('input[name=tipo]').val(tipo);
                        $('input[name=anno]').prop('disabled', true);
                        $('input[name=tipo]').parents('form')[0].submit();
                        return e;
                    }
                );
            }
        );
        $('[data-anno]').each(
            function(i, el) {
                var anno = $(el).data('anno');
                $(el).click(
                    function(e) {
                        e.preventDefault();
                        if ( anno > 0 || anno.length > 0 ) {
                            $('input[name=anno]').val(anno);
                            $('span', '#dropdownYearButton').text(anno);
                            $('input[name=anno]').parents('form')[0].submit();
                        } else {
                            $('input[name=anno]').val('');
                            $('span', '#dropdownYearButton').text('Tutti');
                            $('input[name=anno]').attr('disabled', '');
                            $('input[name=anno]').parents('form')[0].submit();
                        }
                        return e;
                    }
                );
            }
        );
    });
})(jQuery);

(function($) {

    /* Srcset implementation for background-image */
    function imageCurrentSrc(el) {
        var img = $(el);
        return typeof img.prop('currentSrc') !== 'undefined' ? img.prop('currentSrc') : img.attr('src');
    }

    function imageToBackgroundImage(e) {
        var img = e instanceof Event ? e.target : e;
        var container = $(img).parents('.js-bg');
        if ($(img).is('.js-bg__img') || container.find('img').length == 1) {
            container.css('background-image', 'url(' + imageCurrentSrc(img) + ')');
            $(img).hide();
        }
    }

    /* Srcset implementation for background-image */
    function switchSrc(el, parent) {
        var src = imageCurrentSrc(el);
        $(el).parents('.' + parent).css('background-image', 'url(' + src + ')').addClass(parent + '--loaded').end().hide();
    }

    function checkBackgroundImages(params) {
        var parent_selector = 'js-bg';

        $('.' + parent_selector).each(function () {
            var imgs = $(this).find('.js-bg__img').length ? $(this).find('.js-bg__img') : $(this).find('img');
            imgs.on('load', function () {
                switchSrc(this, parent_selector);
            }).each(function () {
                if (this.complete) {
                    switchSrc(this, parent_selector);
                }
            });
        });
    }

    $(document).ready(function() {

		var isMobile = navigator.userAgent.match( /(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i );

        var $project_filter = $('#project-filter');
        var $project_form = $('#project-form');
        if ( $project_filter.length >= 1 ) {
            $('[data-show="true"]').show();
            $('[data-show="false"]').hide();
            $('a', '.cancel-search').click(
                function(e) {
                    $('input', $project_form).each(
                        function(i, input) {
                            $(input).val('');
                        }
                    );
                    $project_form.submit();
                    return e.preventDefault();
                }
            );
            $('a', '.cancel-free-search').click(
                function(e) {
                    $('input[name="cerca"]').each(
                        function(i, input) {
                            $(input).val('');
                        }
                    );
                    $project_form.submit();
                    return e.preventDefault();
                }
            );
            $('input[type="text"]', $project_filter).on(
                'keyup',
                function(e) {
                    var key_code = e.keyCode;
                    var value = $(this).val();
                    $('#project-form-search').val(value);

                    if ( 13 == key_code) {
                        $project_form.submit();
                        e.preventDefault();
                    }

                    return e;
                }
            );
            $('input[type="text"]', $project_filter).on(
                'focus',
                function(e) {
                    $(e.currentTarget).data('ph', $(e.currentTarget).prop('placeholder'));
                    $(e.currentTarget).prop('placeholder', '');

                    return e;
                }
            );

            $('input[type="text"]', $project_filter).on(
                'blur',
                function(e) {
                    $(e.currentTarget).prop('placeholder', $(e.currentTarget).data('ph'));

                    return e;
                }
            );
            $('button.dropdown-item', $project_filter).click(function(e) {
                var $active_sibling = $(this).siblings('.active');
                var text = $($('#' + $(this).data('taxonomy') + '-dropdown').html()).first().text();
                $active_sibling.removeClass('active');
                if ( ('' + $(this).data('slug')).length > 0 ) {
                    $(this).addClass('active');
                }
                $('#project-form-' + $(this).data('taxonomy')).val($(this).data('slug'));
                $('#' + $(this).data('taxonomy') + '-dropdown').empty();
                if ( ('' + $(this).data('slug')).length > 0 ) {
                    // $('#' + $(this).data('taxonomy') + '-dropdown').append($('<span>').text(':'));
                    $('#' + $(this).data('taxonomy') + '-dropdown').append($('<span>').text($(this).data('name')));
                } else {
                    $('#' + $(this).data('taxonomy') + '-dropdown').append($('<span>').text($('#' + $(this).data('taxonomy') + '-dropdown').data('noSelectionText')));
                }

                $project_form.submit();
                return e.preventDefault();
            });
            $('[data-toggle="status"]').click(
                function(e) {
                    var $input = $('#project-form-' + $(this).data('toggle'));
                    var current_value = $input.val();
                    var slug = $(this).data('slug');
                    var status = $(this).data('status');
                    var $current_active = $('[data-toggle="status"]').filter('[data-status="active"]').filter(':not(.d-none)');
                    
                    if ( slug === current_value && $current_active.length > 0 ) {
                        $input.val('');
                        $(this).addClass('d-none');
                    } else if ( $current_active.length > 0 ) {
                        $input.val(slug);
                        $current_active.addClass('d-none');
                        $('[data-slug="' + $current_active.data('slug') + '"]').filter('[data-status="inactive"]').removeClass('d-none');
                        $(this).addClass('d-none');
                    } else {
                        $input.val(slug);
                        $(this).addClass('d-none');
                    }
                    
                    if ( 'active' === status ) {
                        $('[data-slug="' + slug + '"]').filter('[data-status="inactive"]').removeClass('d-none')
                    } else {
                        $('[data-slug="' + slug + '"]').filter('[data-status="active"]').removeClass('d-none')
                    }
                    
                    $project_form.submit();
                    return e.preventDefault();
                }
            );
            $('[data-toggle="patron"]').click(
                function(e) {
                    var $input = $('#project-form-' + $(this).data('toggle'));
                    var current_value = $input.val();
                    var slug = $(this).data('slug');
                    var status = $(this).data('status');
                    var $current_active = $('[data-toggle="patron"]').filter('[data-status="active"]').filter(':not(.d-none)');
                    
                    if ( slug === current_value && $current_active.length > 0 ) {
                        $input.val('');
                        $(this).addClass('d-none');
                    } else if ( $current_active.length > 0 ) {
                        $input.val(slug);
                        $current_active.addClass('d-none');
                        $('[data-slug="' + $current_active.data('slug') + '"]').filter('[data-status="inactive"]').removeClass('d-none');
                        $(this).addClass('d-none');
                    } else {
                        $input.val(slug);
                        $(this).addClass('d-none');
                    }
                    
                    if ( 'active' === status ) {
                        $('[data-slug="' + slug + '"]').filter('[data-status="inactive"]').removeClass('d-none')
                    } else {
                        $('[data-slug="' + slug + '"]').filter('[data-status="active"]').removeClass('d-none')
                    }

                    $project_form.submit();
                    return e.preventDefault();
                }
            );
        }
        // Galleria progetti
        $('a', '.project-gallery').click(
            function(e) {
                $(this).ekkoLightbox({
                    alwaysShowClose: true
                });
                return e.preventDefault();
            }
        );
        // Image with caption
        $('figure.wp-caption').each(
            function(i, el) {
                var $anchor = $(el).parents('a');
                var caption = $('figcaption', el).text();
                var href = '';
                var $img = $('img', el);
                if ( $anchor.length == 0 ) {
                    $anchor = $('<a>');
                    href = $img.prop('src');
                    $anchor.prop('href', href);
                    $anchor.append($img);
                    $(el).prepend($anchor);
                }
                if ( caption.length > 0 ) {
                    $anchor.data('footer', caption);
                }
                
                $anchor.click(
                    function(e) {
                        $(this).ekkoLightbox({alwaysShowClose: true});
                        return e.preventDefault();
                    }
                );
            }
        );
        // block galleries
        var $galleries = $('.wp-block-gallery');
        $galleries.hide();
        $galleries.each(
            function(i, el) {
                var gallery_id = 'gallery-' + i;
                $('.blocks-gallery-item', el).each(
                    function(i, el) {
                        var $figure = $('figure', el);
                        var caption = $('figcaption', el).text();
                        var $anchor = $('a', el);
                        var $img = $('img', el);
                        if ( $anchor.length == 0 ) {
                            $anchor = $('<a>');
                            $anchor.prop('href', $img.data('fullUrl'));
                            $anchor.append($figure);
                            $(el).append($anchor);
                        }

                        if ( caption.length > 0 ) {
                            $anchor.attr('data-footer', caption);
                        }

                        $anchor.attr('data-gallery', gallery_id);
                        $anchor.click(
                            function(e) {
                                $(this).ekkoLightbox({alwaysShowClose: true})
                                return e.preventDefault();
                            }
                        );
                    }
                )
                .promise()
                .then(function() { $(el).fadeIn(); });
            }
        );
        // Audio Video lightbox
        $('[data-toggle="lightbox"]').click(
            function(e) {
                $(this).ekkoLightbox({alwaysShowClose: true});
                return e.preventDefault();
            }
        );
        $('a','[role="tablist"]').on(
            'click',
            function (e) {
                $(this).tab('show');
                location.hash = $(e.target).attr('href').substr(1);
                return e.preventDefault();
            }
        );
        $('a[data-toggle="tab"]').on(
            'shown.bs.tabs',
            function(e) {
                return e.preventDefault();
            }
        );
        if ( location.hash.length > 0 ) {
            $('a[href="' + location.hash + '"]').tab('show');
        }

        // jquery-sticky header
        $('#content.main').waypoint(
            {
                handler: function(direction) {
                    var $header = $('header.header');
                    console.log(arguments);
                    console.log(direction);
                    if ( 'down' === direction ) {
                        $header.addClass('is_stuck');
                    }

                    if ( 'up' === direction ) {
                        $header.removeClass('is_stuck');
                    }
                },
                offset: -10
            }
        );

        var $masonry_partners = $('.masonry--partner');
        var $masonry_container = null;
        macy_instance = null;
        
        if ( $masonry_partners.length > 0 ) {
            $masonry_container = $('<div class="macy--partners" style="visibility:hidden;">');
            $masonry_partners.first().before($masonry_container);
            $masonry_container.append($masonry_partners);
            macy_instance = Macy(
                {
                    container: '.macy--partners',
                    waitForImages: true,
                    margin: {
                        x: 15,
                        y: 15
                    },
                    breakAt: {
                        1200: 3,
                        992: 2,
                        576: 1
                    }
                }
            );
            
            $.when(
                $masonry_container.animate({"height": '100vh'}).promise(),
                $masonry_partners.fadeIn().promise()
            )
            .then(
                function() {
                    macy_instance.recalculate();
                }
            )
            .then(
                function() {
                    $masonry_container.hide()
                    .promise()
                    .then(
                        function() {
                            $masonry_container.css('visibility', '');
                            $masonry_container.fadeIn();
                        }
                    );
                    
                }
            );
        }

        $('.dossier-press-review').each(
            function(i, el) {
                $(el).click(
                    function(e) {
                        e.preventDefault();
                        $form = $('<form method="post" action="/wp-admin/admin-post.php"></form>');
                        $nonce = $('<input type="hidden" name="_nonce" />').val($(this).data('nonce'));
                        $action = $('<input type="hidden" name="action" value="press_review_dossier" />');
                        $project = $('<input type="hidden" name="project" />').val($(this).data('project'));
                        if ( undefined !== $(this).data('year') ) {
                            $year = $('<input type="hidden" name="year" />').val($(this).data('year'));
                            $form.append($year);
                        }

                        $form.append($nonce);
                        $form.append($action);
                        $form.append($project);
                        $('body').append($form);
                        $form.submit();
                        $form.remove();
                    }
                );
            }
        )

        $('[data-toggle="press-reviews"]').each(
            function(i, el) {
                $(el).click(
                    function(e) {
                        var target = $(el).data('target');
                        $(target).show();
                        $(el).parents('.custom-container').hide();
                        return e.preventDefault();
                    }
                );
            }
        );
        
        $('.dropdown-toggle', '#menu-main').each(
            function(i, el) {
                var $menu = $(el);

                $menu.parent().on(
                    'mouseover', 
                    function() {
                        if ( !isMobile && !this.parent().is('.show') ) {
                            this.dropdown('show');
                        }
                    }.bind($menu)
                );

                $menu.parent().on(
                    'mouseout', 
                    function() {
                        if ( !isMobile && this.parent().is('.show')  ) {
                            this.dropdown('hide');
                        }
                    }.bind($menu)
                );

                $menu.on(
                    'click.bs.dropdown',
                    function(e) {
                        var href = this.attr('href');
                        if ( !isMobile ) {
                            this.dropdown('toggle');
                            window.location.href = href;
                        }
                    }.bind($menu)
                );
            }
        );
        
        jQuery(document).ready(function($) {
          $('li.menu-item-has-children > a.dropdown-item', '#menu-main').parent()
            .on('mouseover', function() {
              if (!isMobile) {
                $(this).children('ul.dropdown-menu').addClass('show');
              }
            })
            .on('mouseout', function() {
              if (!isMobile) {
                $(this).children('ul.dropdown-menu').removeClass('show');
              }
            });
        });
        
        
        $('#search-bar__collapse').on(
            'shown.bs.collapse',
            function(e) {
                $('#s', $(this)).focus();
            }
        );

        $('.social__footer--sharer').click(function(e) {
            window.open($(this).attr('href'), 'fullscreen=0,location=0,resizable=0,crollbars=0');

            return e.preventDefault();
        });
        $('#tooltips-data').each(
            function(i, el) {
                var tooltips_data = $(el).data('tooltips');
                $.each(
                    tooltips_data,
                    function(i, tt) {
                        var title = $(i).attr('title');
                        $(i).attr('title', '');
                        var text = '<div class="map-tooltip"><p class="title">{{TITLE}}</p>';
                        text += '<p class="info"><a href="{{PERMALINK}}">{{PROJECT}}</p>';
                        text = text.replace('{{TITLE}}', title);
                        text = text.replace('{{PROJECT}}', tt.PROJECT);
                        text = text.replace('{{PERMALINK}}',tt.PERMALINK);
                        
                        $(i).attr('title', text);
                        $(i).tooltip({html: true,trigger: 'hover focus'});
                        $(i).on(
                            'click',
                            function(e) {
                                var id = '#' + $(e.currentTarget).attr('aria-describedby');
                                window.location.href = $('a', id).prop('href');
                            }
                        );
                        $(i).on(
                            'show.bs.tooltip',
                            function() {
                                $('[aria-describedby^="tooltip"]').tooltip('hide');
                            }
                        );
                    }
                );
            }
        );
        /* Slider activation */
        var slider_opt = {
            items: 1,
            loop: true,
            dots: false,
            nav: true,
            navElement: 'a',
            navText: ['<i class="icon icon-left-arrow"></i>', '<i class="icon icon-right-arrow"></i>'],
            navClass: ['owl-prev', 'owl-next'],
            autoplay: false,
            mouseDrag: false,
            touchDrag: true,
            // autoplayHoverPause: true,
        };

        var sliders = $('.owl-carousel').filter(function () {
            return $(this).find('.slide').length >= 1;
        });

        if (sliders.length > 0) {
            sliders.each(function () {
                var slider = $(this);
                if (slider.is('.slider--home')) {
                    slider.owlCarousel(
                        $.extend(
                            {},
                            slider_opt,
                            {
                                autoplay: false,
                                onInitialized: function(e) {
                                    $('.slider--home .slide').removeClass('d-none');
                                },
                                onTranslated: function(e) {
                                    var $item = $('.owl-item.active video', e.currentTarget);
                                    if ( $item.length > 0 ) {
                                        $item[0].play();
                                    }
                                },
                                onTranslate: function(e) {
                                    var $item = $('.owl-item.active video', e.currentTarget);
                                    if ( $item.length > 0 ) {
                                        $item[0].play();
                                    }
                                }
                            }
                        )
                    );
                    $('button.replay', '.slide').each(
                        function(i, el) {
                            var $video;
                            $video = $(el).parents('.video').find('video');
                            $video.on(
                                'pause',
                                function() {
                                    $(el).show();
                                }
                            );
                            $video.on(
                                'playing',
                                function() {
                                    if ( false === this.ended ) {
                                        $(el).hide();
                                    }
                                }
                            );
                            $(el).click(
                                function(e) {
                                    e.preventDefault();
                                    $video[0].play();
                                    return e;
                                }
                            );
                        }
                    );
                    $('button.volume-down', '.slide').each(
                        function(i, el) {
                            var $video;
                            $video = $(el).parents('.video').find('video');
                            $(el).click(
                                function(e) {
                                    e.preventDefault();
                                    if ( $video[0].ended ) {
                                        return e;
                                    }
                                    if ( !$video[0].muted && $video[0].volume <= 0 ) {
                                        $video[0].muted = true;
                                    }
                                    try {
                                        $video[0].volume -= 0.2;
                                    } catch(error) {
                                        console.info(error);
                                    }
                                    return e;
                                }
                            );
                        }
                    );
                    $('button.volume-up', '.slide').each(
                        function(i, el) {
                            var $video;
                            $video = $(el).parents('.video').find('video');
                            $(el).click(
                                function(e) {
                                    e.preventDefault();
                                    if ( $video[0].ended ) {
                                        return e;
                                    }
                                    if ( $video[0].muted ) {
                                        $video[0].muted = false;
                                    }
                                    try {
                                        $video[0].volume += 0.2;
                                    } catch(error) {
                                        console.info(error);
                                    }
                                    return e;
                                }
                            );
                        }
                    );
                } else if (slider.is('.slider--project')) {
                    slider.owlCarousel(
                        $.extend(
                            {},
                            slider_opt,
                            {
                                items: 3,
                                loop: false
                            }  
                        )
                    );
                } else if (slider.is('.slider--home-news')) {
                    slider.owlCarousel(
                        $.extend(
                            {},
                            slider_opt,
                            {
                                items: 3,
                                loop: false,
                                nav: false,
                                responsive: {
                                    0: {
                                        items: 1,
                                        nav: true,
                                        loop: true
                                    },
                                    992: {
                                        items: 3,
                                        nav: false,
                                        loop: false
                                    }
                                }
                            }  
                        )
                    );
                } else if (slider.is('.slider--our-projects')) {
                    slider.owlCarousel(
                        $.extend(
                            {},
                            slider_opt,
                            {
                                items: 2,
                                loop: false,
                                margin: 30,
                                responsive: {
                                    0: {
                                        items: 1,
                                        nav: true,
                                    },
                                    992: {
                                        items: 2,
                                        nav: true,
                                        nav: true,
                                        margin: 30,
                                    }
                                }
                            }  
                        )
                    );
                } else if (slider.is('.slider--the-history')) {
                    slider.owlCarousel(
                        $.extend(
                            {},
                            slider_opt,
                            {
                                items: 1,
                                loop: false,
                                dots: false,
                                nav: false,
                                autoplay: false,
                                URLhashListener: true,
                                smartSpeed: 1200,
                                onInitialize: function(e) {
                                    var $target = $(e.target);
                                    $target.fadeIn(4000)
                                    .promise()
                                    .done(
                                        function() {
                                            var $slides = $('[data-hash]', $target);
                                            var year = location.hash.replace('#', '');
                                            var last = $slides.length - 1;
                                            var slide = last;

                                            $slides.each(
                                                function(i, el) {
                                                    var hash = $(el).data('hash');
                                                    if ( year == hash ) {
                                                        slide = i;
                                                    }
                                                }
                                            );
                                            $target.trigger('to.owl.carousel', [ slide, 1200 ] );
                                        }
                                    );
                                },
                                onTranslate: function(e) {
                                    var index = e.item.index;
                                    var hash = $($('.slide', e.currentTarget)[index]).data('hash');
                                    var $selected = $('[data-year=' + hash + ']');
                                    var $slider = $selected.parents('.slider');
                                    $slider.trigger('to.owl.carousel', [ index, 1200 ]);
                                    $('[data-year]').parents('.owl-item').removeClass('selected');
                                    $selected.parents('.owl-item').addClass('selected');
                                }
                            }  
                        )
                    );
                } else if (slider.is('.slider--the-history-dots')) {
                    slider.owlCarousel(
                        $.extend(
                            {},
                            slider_opt,
                            {
                                items: 5,
                                loop: false,
                                dots: false,
                                nav: true,
                                center: false,
                                autoplay: false,
                                responsive: {
                                    0: {
                                        items: 3,
                                        nav: true
                                    },
                                    992: {
                                        items: 5,
                                        nav: true
                                    }
                                },
                                onInitialize: function(e) {
                                    var $target = $(e.target);
                                    $target.fadeIn(4000);
                                }
                                
                            }  
                        )
                    );
                } else {
                    slider.owlCarousel(slider_opt);
                }
            });
        }
        /* activate lazy loading */
        checkBackgroundImages();
    });
})(jQuery.noConflict());
